
import * as EVENTS from '@/utils/constants/socket-events'

import CaseBattlesGame from '@/store/models/games/case-battles/CaseBattlesGame'
import { GAME_STATUS, parseGame } from '@/views/games/CaseBattles/utils'


export default {
  [`SOCKET_${EVENTS.GAME_CASE_BATTLES_LIST}`](_, games) {
    // TODO decide if we want to just insert and purge in here :)
    CaseBattlesGame.create({
      data: games.map(i => parseGame(i)),
    })
  },
  [`SOCKET_${EVENTS.GAME_CASE_BATTLES_NEW}`](_, game) {
    CaseBattlesGame.insert({ data: parseGame(game) })
  },
  [`SOCKET_${EVENTS.GAME_CASE_BATTLES_PLAYER_JOINED}`](_, { id, player, expiresAtDifferenceMs }) {
    CaseBattlesGame.update({
      where: id,
      data(record) {
        record.players = {
          ...record.players,
          [player.steamid]: player,
        }

        record.expiresAt = Date.now() + expiresAtDifferenceMs
      },
    })
  },
  [`SOCKET_${EVENTS.GAME_CASE_BATTLES_LOCK}`]({ rootGetters }, { id, solvingBlockId }) {
    const conga = rootGetters['conga/conga']
    const { time } = conga.games.caseBattles

    CaseBattlesGame.update({
      where: id,
      data(record) {
        record.status = GAME_STATUS.locked
        record.fairness = {
          ...record.fairness,
          solvingBlockId,
        }
        record.lockingAt = Date.now() + time.countdown
      },
    })
  },
  [`SOCKET_${EVENTS.GAME_CASE_BATTLES_ROLL_ROUND}`](_, { id, round, items }) {
    CaseBattlesGame.update({
      where: id,
      data(record) {
        record.status = GAME_STATUS.rolling
        record.round = round
        record.lastRoundAt = Date.now()
        record.items = [...record.items, ...items]
      },
    })
  },
  [`SOCKET_${EVENTS.GAME_CASE_BATTLES_FINISHED}`]({ rootGetters }, game) {
    CaseBattlesGame.update({
      where: game.id,
      data(record) {
        record.status = GAME_STATUS.complete
        record.fairness = game.fairness
        record.data = {
          winningTeams: game.winningTeams,
          totalWon: game.totalWon,
        }
        record.finishedAt = Date.now()
      },
    })

    const conga = rootGetters['conga/conga']
    const { time } = conga.games.caseBattles

    // trigger an update after
    setTimeout(() => {
      CaseBattlesGame.update({
        where: game.id,
        data: { canShowWinners: true },
      })
    }, time.roll + time.tally)
  },
  [`SOCKET_${EVENTS.GAME_CASE_BATTLES_EXPIRED}`](_, ids) {
    CaseBattlesGame.delete(game => ids.includes(game.id))
  },
}
